import { gql } from 'apollo-boost';

export default gql`
  mutation closeTableServiceOrder($input: CloseTableServiceOrderInput!) {
    closeTableServiceOrder(input: $input)
  }
`;
